// loops through the error states and returns true if any errors are found
export const errorCheck = (errors) => {
  let res = false;
  Object.keys(errors).forEach((field) => {
    if (errors[field] === true) {
      res = true;
    }
  });
  return res;
};

export const setErrorMessage = (hasError, errorMessage) => {
  let res = '';
  if(hasError){
    res = errorMessage;
  }
  return res;
};